import React from "react";

import { ScimLogModelFrontend } from "@performyard/service-contracts";

import FormattedDateTime from "../../../../components/FormattedDateTime";

// Returns correct color string for Chip component prop from scim log status
export const getStatusColor = (status: string) => {
	switch (status) {
		case "failed":
			return "red";
		case "completed":
			return "green";
		default:
			return "green";
	}
};

// Returns FormattedDateTime component with correct props from scim log values
export const getEventTimeCell = (scimLog: ScimLogModelFrontend) => {
	if (!scimLog || !scimLog.timestamp) {
		return "";
	}
	return (
		<FormattedDateTime
			dateSize="medium"
			hasTime={true}
			delimiter={"•"}
			date={scimLog.timestamp}
			size="paragraph-3"
		/>
	);
};

// Filters values that shouldn't be displayed in details modal from scim log
export const filterScimLog = (scimLog: ScimLogModelFrontend) => {
	const removeTypes = ["Activation Status", "Termination Date"];
	if (scimLog.scimLogType === "deactivate") {
		const filteredUpdates = scimLog.updates.filter((update) => !removeTypes.includes(update.name));
		return {
			...scimLog,
			updates: filteredUpdates,
		};
	}

	return scimLog;
};
